<h1 class="h1">{{ title | translate }}</h1>
<router-outlet></router-outlet>